import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
const TicketPool = lazy(() => import('../../pages/tickets/ticket-pool'));

function PagesRoute() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route exact path={path} component={TicketPool} />
            <Route exact path={`${path}/pool`} component={TicketPool} />
            <Route exact path={`${path}/:uuid`} component={TicketPool} />
        </Switch>
    );
}

export default PagesRoute;
